import script from "./RandomCardGame.vue?vue&type=script&setup=true&lang=js"
export * from "./RandomCardGame.vue?vue&type=script&setup=true&lang=js"

import "./RandomCardGame.vue?vue&type=style&index=0&id=ba820952&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba820952"]])

export default __exports__